<template>
    <div class="content-wrapper">
        <PageHeader screenName="Cadastrar nova" :linkItems="linkItems" />

        <ConfirmModal itemIdentifier="usuário" :modalShow="modal.showModal" :typeModal="modal.typeModal"
            @confirmed="redirecionarLista" @canceled="closeModalConfirm" />

        <SucessoModal :modalShow="modalSucesso.showModal" :typeModal="modalSucesso.typeModal"
            :caseModal="modalSucesso.caseModal" @confirmed="redirecionarLista" />

        <TimedAlert variant="success" message="Dose salva com sucesso!" :show="savedAlert" />

        <main class="card p-2">
            <section class="form">
                <validation-observer ref="doseRules">
                    <b-form>
                        <b-row>
                            <b-col lg="3" md="3" sm="12">
                                <b-form-group label="Código da Dose*" label-for="codigo-dose-input"
                                    label-class="label_size_dose">
                                    <validation-provider #default="{ errors }" name="CodigoDose" rules="required">
                                        <b-form-input :state="errors.length > 0 || form.errorApi.br_dose ? false : null"
                                            id="codigo-dose-input" v-model="form.br_dose" placeholder="Ex: 1"
                                            v-mask="'##########'" />
                                        <small class="text-muted">
                                            Códido cadastrado no BRDose - RNDS CodeSystem.
                                        </small>
                                        <br>
                                        <small v-if="errors[0]" class="text-danger">
                                            Este campo é de preenchimento obrigatório.
                                        </small>
                                        <small v-if="form.errorApi.br_dose" class="text-danger">
                                            {{ form.errorApi.br_dose }}
                                        </small>
                                        <small v-if="form.errorApi.error" class="text-danger">
                                            {{ form.errorApi.error }}
                                        </small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col lg="6" md="6" sm="12">
                                <b-form-group label="Nome da Dose*" label-for="descricao-input"
                                    label-class="label_size_dose">
                                    <validation-provider #default="{ errors }" name="DescricaoDose" rules="required">
                                        <b-form-input
                                            :state="errors.length > 0 || form.errorApi.descricao || form.errorApi.error ? false : null"
                                            id="descricao-dose-input" v-model="form.descricao"
                                            placeholder="Ex: 1ª Dose, Reforço, Dose Adicional"
                                            v-mask="('X'.repeat(250))" />
                                        <small class="text-muted">
                                            Nome cadastrado no BRDose - RNDS CodeSystem.
                                        </small>
                                        <br>
                                        <small v-if="errors[0]" class="text-danger">
                                            Este campo é de preenchimento obrigatório.
                                        </small>
                                        <small v-if="form.errorApi.descricao" class="text-danger">
                                            {{ form.errorApi.descricao }}
                                        </small>
                                        <small v-if="form.errorApi.error" class="text-danger">
                                            {{ form.errorApi.error }}
                                        </small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <validation-provider #default="{ errors }" name="StatusDose" rules="required">
                                    <b-form-group label="Status*" label-for="status-dose-input"
                                        label-class="label_size_dose" :state="errors.length > 0 ||
                                            form.errorApi.ativo
                                            ? false
                                            : null
                                            ">
                                        <v-select id="status-dose-input" v-model="form.ativo" :options="statusOptions"
                                            label="label" :reduce="option => option.value"
                                            placeholder="Selecione o status" :clearable="false">
                                            <span slot="no-options">Nenhuma opção selecionável.</span>
                                        </v-select>
                                        <small v-if="errors[0]" class="text-danger">
                                            Este campo é de preenchimento obrigatório.
                                        </small>
                                        <small v-if="form.errorApi.ativo" class="text-danger">
                                            {{ form.errorApi.ativo }}
                                        </small>
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                        </b-row>
                    </b-form>
                </validation-observer>
            </section>
            <section class="buttons">
                <b-button id="save-dose" class="mr-2 mt-2" variant="custom-blue" @click.prevent="validationForm(true)"
                    :disabled="saving || savingAndNew">
                    <feather-icon icon="CheckIcon" class="mr-50" />
                    <span class="align-middle">Salvar dose</span>
                    <output v-if="saving" aria-live="polite" class="ml-1">
                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                        <span class="sr-only">Salvando...</span>
                    </output>
                </b-button>
                <b-button id="save-dose" class="mr-2 mt-2" variant="custom-blue" @click.prevent="validationForm(false)"
                    :disabled="saving || savingAndNew">
                    <feather-icon icon="CheckIcon" class="mr-50" />
                    <span class="align-middle">Salvar e cadastrar uma nova</span>
                    <output v-if="savingAndNew" aria-live="polite" class="ml-1">
                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                        <span class="sr-only">Salvando e adicionando novo...</span>
                    </output>
                </b-button>
                <b-button id="cancel-register-dose" :disabled="saving || savingAndNew" variant="outline-danger"
                    @click.prevent="openModalConfirm" class="mt-2">
                    <feather-icon icon="XIcon" class="mr-50" />
                    <span class="align-middle">Cancelar</span>
                </b-button>
            </section>
        </main>
    </div>
</template>

<script>
import { BRow, BCol, BForm, BFormGroup, BFormInput, BFormRadio, BButton, BFormTextarea } from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import TimedAlert from '@/views/components/custom/timed-alert/TimedAlert.vue'
import PageHeader from '@/views/components/custom/page-header/PageHeader.vue'
import ConfirmModal from '@/views/components/custom/modals/ConfirmModal.vue'
import SucessoModal from '@/views/components/custom/modals/SucessoCriacaoEdicaoModal.vue'
import handleErrorsService from './Services/HandleErrors'

export default {
    title: 'Cadastrar dose',

    components: {
        BRow, BCol, BForm, BFormGroup, BFormInput, BFormRadio, BFormTextarea,
        BButton, vSelect, ValidationProvider, ValidationObserver,
        TimedAlert, PageHeader, ConfirmModal, SucessoModal
    },

    data() {
        return {
            linkItems: [
                {
                    name: 'Doses',
                    routeName: 'dose-list'
                },
                {
                    name: 'Cadastrar nova',
                    active: true
                }
            ],
            modal: {
                showModal: false,
                typeModal: 'danger'
            },
            modalSucesso: {
                showModal: false,
                typeModal: 'success',
                caseModal: 'criacao'
            },
            statusOptions: [
                { label: 'Ativo', value: true },
                { label: 'Inativo', value: false }
            ],
            required,
            savedAlert: false,
            saving: false,
            savingAndNew: false,
            form: {
                descricao: '',
                br_dose: '',
                ativo: true,
                errorApi: {
                    descricao: '',
                    br_dose: '',
                    ativo: '',
                    error: ''
                }
            }
        }
    },

    methods: {
        validationForm(redirectToList) {
            this.$refs.doseRules.validate().then(success => {
                if (success) {
                    if (redirectToList) {
                        this.saving = true;
                    } else {
                        this.savingAndNew = true;
                    }
                    this.saveDose(redirectToList);
                }
            })
        },

        saveDose(redirectToList) {
            const parameters = {
                'descricao': this.form.descricao,
                'br_dose': this.form.br_dose,
                'ativo': this.form.ativo,
            }

            this.$http.post(this.$api.saveAndGetDose(), parameters).then(() => {
                if (redirectToList) {
                    this.openModalSucesso();
                } else {
                    this.savedAlert = !this.savedAlert;
                }

                this.saving = false;
                this.savingAndNew = false;
                this.cleanForm();

            }).catch(({ response: { data } }) => {
                handleErrorsService.handleErrosDose(data, this.form.errorApi);

                this.saving = false;
                this.savingAndNew = false;
            })
        },

        cleanForm() {
            this.form.descricao = '';
            this.form.br_dose = '';
            this.form.ativo = true;

            this.form.errorApi.descricao = '';
            this.form.errorApi.br_dose = '';
            this.form.errorApi.ativo = '';
            this.form.errorApi.error = ''

            this.$refs.doseRules.reset();
        },

        redirecionarLista() {
            this.$router.push({ name: 'dose-list' });
        },

        openModalConfirm() {
            this.modal.showModal = true;
        },

        closeModalConfirm() {
            this.modal.showModal = false;
        },

        openModalSucesso() {
            this.modalSucesso.showModal = true;
        }
    }
}
</script>
